<template>
  <div class="main-container">
    <section v-if="!isPc" class="downloads-container" :style="bgStyle">
      <header>
        <img src="../assets/images/ic_logo.png" width="64px" height="64px">
        <span>官方</span>
      </header>
      <footer>
        <div v-waves v-debounces:click.500="onDownload">立即下载</div>
      </footer>
    </section>
    <pc-view v-else />
    <div v-if="isWx" class="wx-guide" :style="bgStyle"></div>
  </div>
</template>

<script>
import { getOSType, getViewPortHeight } from '@/utils'
import PcView from '@/components/PcView'

const platformVal = getOSType()
const OPEN_URL = 'fxwallet://'
const ANRROID_LINK = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.wallet.pay'
const IOS_LINK = 'https://apps.apple.com/cn/app/%E5%A4%8D%E6%98%9F%E9%92%B1%E5%8C%85/id1155456006'

export default {
  components: {
    PcView
  },
  data() {
    return {
      isPc: false,
      bgStyle: {
        height: '100vh',
        minHeight: '568px'
      },
      checkOpen: null,
      isWx: false
    }
  },
  created() {
    const that = this
    this.isWx = /MicroMessenger/.test(window.navigator.userAgent) || /AlipayClient/.test(window.navigator.userAgent)
    window.onresize = function() {
      that.isPc = getOSType() === 2
    }
  },
  mounted() {
    this.$nextTick(() => {
      const heights = `${getViewPortHeight()}px`
      this.bgStyle = {
        height: heights,
        minHeight: heights
      }
    })
    // this.initStatus()
  },
  destroyed() {
    console.log('关闭页面')
    this.cancelTimer()
  },
  methods: {
    initStatus() {
      if (platformVal !== 2) {
        this.isPc = false
        if (platformVal === 0) { // ios
        } else if (platformVal === 1) { // android
        }
      } else { // pc
        this.isPc = true
      }
    },
    openApp(url, callback) {
      // window.location.href = url;
      // var timeout, t = 4000, hasApp = true;
      // var openScript = setTimeout(function() { 
      //   if (!hasApp) {
      //     callback && callback()
      //   }
      //   document.body.removeChild(ifr);
      // }, 5000)

      // var t1 = Date.now();
      // var ifr = document.createElement('iframe');
      // ifr.setAttribute('src', url);
      // ifr.setAttribute('style', 'display:none');
      // document.body.appendChild(ifr);

      // timeout = setTimeout(function() {
      //   var t2 = Date.now();
      //   if (t2 - t1 < t + 100) {
      //     hasApp = false;
      //   }
      // }, t);

      // 唤起 APP，如果被唤起的话，页面就会进入后台运行，setInterval 在 ios 中不会停止运行，在 android 中停止运行
      window.location.href = url;
      const that = this
      const initialTime = new Date();
      let waitTime = 0;

      // 每 20ms 执行一次
      // 我们的判断条件比预期时间多设置了 500ms，所以如果安卓中 setInterval 内的函数执行 100 次以内所费时间超过 2500ms，
      // 则说明 APP 唤起成功，反之则代表失败。
      this.checkOpen = setInterval(() => {
        waitTime = new Date() - initialTime;
        if (waitTime > 2500) {
          that.cancelTimer()
          callback && callback(); // 唤端失败的回调函数
        }
      }, 20);
    },
    onDownload() {
      if (platformVal !== 2) {
        this.openApp(OPEN_URL, () => {
          if (platformVal === 1) { // 打开安卓应用市场
            window.location.href = ANRROID_LINK;
          } else { // 打开AppStore
            window.location.href = IOS_LINK;
          }
        })
      }
    },
    cancelTimer() {
      clearInterval(this.checkOpen);
      this.checkOpen = null
    }
  }
}
</script>

<style lang="less" scoped>
.downloads-container {
  position: relative;
  width: 100%;
  height: 100vh;
  max-width: 720px;
  margin: 0 auto;
  background: url('../assets/images/ic_download.png');
  background-size: 100% 100%;
  header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    >img {
      padding-top: 8%;
    }
    span {
      display: inline-block;
      width: 54px;
      height: 20px;
      margin-top: 5px;
      background: #44A6FF;
      border-radius: 10px;
      font-weight: 400;
      line-height: 20px;
      font-size: 14px;
      color: #FFFFFF;
    }
  }
  footer {
    position: absolute;
    width: 94%;
    height: 44px;
    left: 3%;
    bottom: 13.5%;
    line-height: 44px;
    background: linear-gradient(180deg, #FFFFFF 0%, #E9E9E9 100%);
    box-shadow: 0px 2px 15px 0px rgba(25, 64, 114, 0.25);
    border-radius: 22px;
    text-align: center;
    div {
      border-radius: 22px;
      font-weight: 500;
      color: #3293FF;
      line-height: 44px;
    }
  }
}
.main-container {
  position: relative;
}
.wx-guide {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: url('../assets/images/wx_bg.png');
  background-color: rgba(0, 0, 0, 0.5);
  background-size: 100% 100%;
}
</style>